export default {
  SendVerificationButton: 'verification-form__send-verification-button',
  VerifyButton: 'verification-form__verify-button',
  ContinueButton: 'verification-form__continue-button',
  GoBackButton: 'verificationform__go-back-button'
};
